export const sourceOptions = {
    LINK: "link",
    PUSH: "push",
    TAB_BAR: "tabBar",
} as const
